module.exports = __webpack_public_path__ + "static/media/Web-Development.2f01ea5d.png";